import { Stack } from '@mui/material'
import { useFormContext, useWatch } from 'react-hook-form'

import { ControlledDatePicker, ControlledSelector } from 'components/common/controller-wrapper'
import {
  BID_ANALYSIS_EARLIEST_DATE,
  TIME_PERIODS,
  VEHICLE_TYPES,
} from 'components/reports/Metrics/constants'

import { BidAnalysisFilterValues } from './BidAnalysisFilterCriteria'
import { BidAnalysisServiceCodeAutocomplete } from './BidAnalysisServiceCodeAutocomplete'

export const BidAnalysisFiltersForm = () => {
  const { control } = useFormContext<BidAnalysisFilterValues>()
  const period = useWatch({ control, name: 'period' })
  const customStart = useWatch({ control, name: 'customStart' })
  const customEnd = useWatch({ control, name: 'customEnd' })
  const isCustom = period === 'custom'

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      useFlexGap
      flexWrap='wrap'
      alignItems={{ xs: 'stretch', sm: 'flex-end' }}>
      <ControlledSelector
        control={control}
        name='period'
        label='Period'
        options={TIME_PERIODS}
        size='small'
        fullWidth={false}
        sx={{ minWidth: 160 }}
      />

      {isCustom && (
        <>
          <ControlledDatePicker
            control={control}
            name='customStart'
            label='From'
            minDate={BID_ANALYSIS_EARLIEST_DATE}
            maxDate={customEnd ?? new Date()}
            size='small'
            fullWidth={false}
            sx={{ minWidth: 150 }}
          />
          <ControlledDatePicker
            control={control}
            name='customEnd'
            label='To'
            minDate={customStart ?? BID_ANALYSIS_EARLIEST_DATE}
            maxDate={new Date()}
            size='small'
            fullWidth={false}
            sx={{ minWidth: 150 }}
          />
        </>
      )}

      <BidAnalysisServiceCodeAutocomplete />

      <ControlledSelector
        control={control}
        name='vehicleType'
        label='Vehicle type'
        options={VEHICLE_TYPES}
        size='small'
        fullWidth={false}
        sx={{ minWidth: 170 }}
      />
    </Stack>
  )
}
